<template>
  <div class="px-4 py-4">
    <h3>How are the dose response curves fitted? What are the parameters for fitting?</h3>
    <DrcDetails></DrcDetails>
    <br>
    <h3>What are the three curves in the dose response graph?</h3>
    <ul>
        <li>Single Treatment - Dose response curve of the compound which is being varied in the combination screen by itself</li>
        <li>Combination - Dose response curve of the compound being varied with an anchor compound and dose</li>
        <li>Bliss - The expected dose response curve assuming independent interaction of the single treatment compound and anchor compound. As such, the model assumes the log fold changes (LFCs) of the single compound and anchor compound for respective fixed doses are additive (i.e. their fold changes (FCs) are multiplicative).</li>
    </ul>
    <h3>How is AUC calculated for combination and expected Bliss?</h3>
    <br><br>
    <DrcComboDetails></DrcComboDetails>
    <br><br>
    <h3>What is synergy score? How is the MSS calculated?</h3>
    <SynergyScoreDetails></SynergyScoreDetails>
    <br><br>
    The mean synergy score (MSS) is an average metric of synergy across doses for a given compound. Because synergy score is calculated in terms of LFC (<span class="math-block"><vue-mathjax :formula="'$$LFC_a + LFC_b - LFC_c$$'"></vue-mathjax></span>), the mean synergy score (MSS) is as follows:
    <br><br>
    <vue-mathjax :formula="'$$MSS =log(\\frac{AUC_{bliss}}{AUC_{combo}}) \\approx\\log(\\frac{{\\frac{1}{n}\\sum_{i=1}^nFC_{a_i}FC_b}}{\\frac{1}{n}\\sum_{i=1}^nFC_{c_i}})$$'"></vue-mathjax>
  </div>
</template>

<script>
//  import * as d3 from 'd3';
import DrcDetails from '@/dynamic-content/DrcDetails.vue';
import DrcComboDetails from '@/dynamic-content/DrcComboDetails.vue';
import SynergyScoreDetails from '@/dynamic-content/SynergyScoreDetails.vue';

export default {
  name: 'dose-response-combo-drawer',
  components: { DrcDetails, DrcComboDetails, SynergyScoreDetails },
  mounted() {

  },
  methods: {},
  watch: {}
}
</script>

<style scoped>


</style>
